import { render, staticRenderFns } from "./SettingsIcon.vue?vue&type=template&id=98c894ac&scoped=true&"
import script from "./SettingsIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsIcon.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIcon.vue?vue&type=style&index=0&id=98c894ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c894ac",
  null
  
)

export default component.exports